import { Autocomplete, Button, Field, SearchField } from 'components/commons';
import React, { useCallback } from 'react';
import styles from './savings-filter.module.scss';
import { prettifyCustomerStatus } from 'utils';
import locale from 'localization';
import CustomerStatus from 'enums/driver-status';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Path } from 'enums';

const SavingsFilter = ({ filterState, onStatusChange, onSearchChange, onSearch, fetchingReport, onDownloadFile }) => {
  const history = useHistory();

  const onStatusChangeCb = useCallback(
    (name, { value }) => {
      if (onStatusChange) return onStatusChange(value || 'all');
    },
    [onStatusChange]
  );

  const onSearchChangeCb = useCallback(
    (name, { value }) => {
      if (onSearchChange) {
        return onSearchChange('searchKey', { value });
      }
    },
    [onSearchChange]
  );

  const onSearchCb = useCallback(
    (searchKey) => {
      if (onSearch) {
        return onSearch(searchKey);
      }
    },
    [onSearch]
  );

  return (
    <div className={styles.filter}>
      <div className={styles.filterContent}>
        <Field className={styles.status} label="Status">
          <Autocomplete
            name="status"
            value={filterState.status}
            options={[
              { label: locale.all, value: 'all' },
              {
                label: prettifyCustomerStatus(CustomerStatus.Active),
                value: CustomerStatus.Active
              },
              {
                label: prettifyCustomerStatus(CustomerStatus.Inactive),
                value: CustomerStatus.Inactive
              }
            ]}
            onChange={onStatusChangeCb}
          />
        </Field>
        <Field className={styles.search} label="Search">
          <SearchField
            placeholder={'Customer Account Number, Name, Membership ID'}
            value={filterState.searchKey}
            onChange={onSearchChangeCb}
            onEnter={onSearchCb}
            restrict={false}
          />
        </Field>
      </div>
      <Field className={styles.downloadButton}>
        <Button exportButton onClick={onDownloadFile}>
          Generate Report
        </Button>
      </Field>

      <Field>
        <Button
          className={styles.transactionsButton}
          onClick={() => {
            history.push(Path.TransactionByProduct('savings'));
          }}
        >
          View Transactions Report
        </Button>
      </Field>
    </div>
  );
};

export default SavingsFilter;
